import { ACCESS_TOKEN_KEY } from "@services/api/constants";

const setAccessToken = (token: any, expiresAt: string) => {
    const tokenData = {
        token,
        expiresAt,
        type: "applicant"
    };
    localStorage.setItem(ACCESS_TOKEN_KEY, JSON.stringify(tokenData));
}

export default setAccessToken;